<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    width="800px"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" label-suffix="：" :rules="rules" inline>
      <div>
        <!-- <el-form-item label="服务机构" prop="companyIds"> -->
        <el-form-item label="综合服务单位" prop="companyIds">
          <el-select
            v-model="form.companyIds"
            filterable
            multiple
            placeholder="请选择综合服务单位"
          >
            <el-option
              v-for="item in this.serviceList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { createBatch } from '@/api/business/projectSo'
import { list } from '@/api/business/company'
export default {
  name: 'OperaContentComprehenWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      // 表单数据
      form: {
        projectId: null,
        companyIds: [],
        type: 1
      },
      serviceList: [],
      
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/areas',
      'field.id': 'id'
    })
    // this.getServiceList()
  },
  methods: {
    getServiceList(projectId) {
      list({ type: '2', noProjectId: projectId })
        .then(res => {
          this.serviceList = res
        })
    },
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.getServiceList(this.form.projectId)
      })
    },
    confirm () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        // 调用新建接口
        this.isWorking = true
        createBatch({
          ...this.form,
          type: 1
        })
          .then(() => {
            this.visible = false
            this.$message.success('新建成功')
            this.$emit('success')
          })
          .catch(e => {
            this.$message.error(e)
          })
          .finally(() => {
            this.isWorking = false
          })
      })
    },
    inputAction(value) {
      if(this.form.price<0) {
        this.form.price = ''
      } else {
        this.form.price = value.replace(/[^\d.]/g, '')
                      .replace(/\.{2,}/g, '.')
                      .replace('.', '$#$')
                      .replace(/\./g, '')
                      .replace('$#$', '.')
                      .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
                      .replace(/^\./g, '')
      }
      console.log(this.form.price);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
    .el-input__inner {
      width: 100%;
    }
  }

</style>
